module.exports = {
      id: "icon-card-amex-usage",
      viewBox: "0 0 44 24",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-card-amex",
      toString: function () {
        return this.url;
      }
    }